// extracted by mini-css-extract-plugin
export default {"container":"login_modal-module__container--2rWNz","close":"login_modal-module__close--_2zm0","title":"login_modal-module__title--yKLGe"};